export const messages = {
  en: {
    downShopHouseOutManage: {
      title: 'Return Order Management',
      chooseOrder: 'Select Order',
      orderId: 'Order ID',
      createTime: 'Create Time',
      status: 'Status',
      productId: 'Product ID',
      productName: 'Product Name',
      specification: 'Specification',
      purchaseQuantity: 'Purchase Quantity',
      quantity: 'Quantity',
      price: 'Price',
      operation: 'Operation',
      amount: 'Amount',
      returnRemark: 'Return Remark',
      submit: 'Submit',
      cancel: 'Cancel',
      delete: 'Delete',
      selectProduct: 'Select Product',
      requiredRemark: 'Remark is required',
      validQuantity: 'Please enter valid quantity',
      exceedQuantity: 'Return quantity cannot exceed purchase quantity'
    }
  },
  zh: {
    downShopHouseOutManage: {
      title: '退货订单管理',
      chooseOrder: '选择订单',
      orderId: '订单编号',
      createTime: '创建时间',
      status: '状态',
      productId: '商品编号',
      productName: '商品名称',
      specification: '规格',
      purchaseQuantity: '进货数量',
      quantity: '数量',
      price: '单价',
      operation: '操作',
      amount: '金额',
      returnRemark: '退货说明',
      submit: '提交',
      cancel: '取消',
      delete: '删除',
      selectProduct: '选择商品',
      requiredRemark: '请填写退货说明',
      validQuantity: '请输入正确的数量',
      exceedQuantity: '退货数量不能大于进库数量'
    }
  }
}